export const routeMap: any = {
    'server.view': 'serv',
    'Servers': 'serv',
    'ServerContainers': 'serv/:serverId',
    'container.view': 'containers',
    'translation.view': 'languages',
    'permission.edit': 'persons',
};
